import React, {useCallback, useEffect, useState} from 'react'
import {Container} from '../components'
import {CompanyModel, GetCompanyByIdModel} from './models/GetCompanyByIdModel'
import {Error404NotFound} from '../../pages/errors/Error404NotFound'
import axios from 'axios'
import EditInfoCompanyModal from './modals/EditInfoCompanyModal'
import InternalNavigation from '../internalNavigation/InternalNavigation'
import InfoShowCompanySubpage from './subpages/show/InfoShowCompanySubpage'
import AddressShowCompanySubpage from './subpages/show/AddressShowCompanySubpage'

const CompanyPage: React.FC = () => {
    const [loading, setLoading] = useState(true)
    const [company, setCompany] = useState<CompanyModel>()
    const [isOpenModal, setIsOpenModal] = useState(false)

    const getData = useCallback(async () => {
        try {
            const {data} = await axios.get<GetCompanyByIdModel>(`/company/show`)
            setCompany(data.data.company)
        } finally {
            setLoading(false)
        }
    }, [])

    useEffect(() => {
        getData()
    }, [getData])

    return (
        <div className='row'>
            <Container loading={loading}>
                {company !== undefined ? (
                    <InternalNavigation
                        labels={['Informações', 'Endereço']}
                        pages={{
                            data: (
                                <InfoShowCompanySubpage
                                    company={company}
                                    getData={() => getData()}
                                />
                            ),
                            pdv_address: (
                                <AddressShowCompanySubpage
                                    company={company}
                                    address={company.address}
                                    getData={() => getData()}
                                />
                            ),
                        }}
                        titleSubmit='Cadastrar'
                        buttonNext={false}
                    />
                ) : (
                    <Error404NotFound />
                )}
            </Container>

            {company !== undefined && (
                <EditInfoCompanyModal
                    isOpen={isOpenModal}
                    onClose={setIsOpenModal}
                    onUpdate={() => getData()}
                    company={company}
                />
            )}
        </div>
    )
}

export default CompanyPage
